import RelatedNews from "./related-news.component";

export default RelatedNews;
